import { Modal } from 'antd';
import { Button } from 'components/Button';
import React, { useState } from 'react'
import { connect } from 'react-redux';

function BatchDeleteModal({ showConfirmDeleteModal, setConfirmDeleteModal, handleYes, className, sectionName }) {
    const handleCancel = () => {
        setConfirmDeleteModal(false)
    }
    // const [unassignLoader, setUnassignLoader] = useState(false);

    return (
        <>
            <Modal
                className="modal-round-corner"
                centered
                visible={showConfirmDeleteModal}
                onOk={handleYes}
                onCancel={handleCancel}
                header={null}
                footer={null}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                    }}
                >
                    <div style={{ fontSize: "20px", color: "#191919", fontWeight: "bold" }}>Confirm</div>
                    <div
                        style={{
                            fontSize: "16px",
                            color: "#636363",
                            fontFamily: "roboto",
                            marginTop: "10px",
                            textAlign: 'center'
                        }}
                    >
                        {
                        <p>Are you sure you want to delete <span style={{ fontWeight: "bold" }}>{`${className} : ${sectionName}`}</span>?</p>
                        }
                    </div>
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        marginTop: "50px",
                        marginBottom: 20
                    }}
                >
                    <Button
                        // loading={unassignLoader}
                        style={{ color: "red", fontWeight: "bold", fontFamily: "roboto", border: "none" }}
                        onClick={() => {
                            handleYes()
                        }}
                    >
                         DELETE
                    </Button>
                    <Button
                        loading={null}
                        type='primary'
                        onClick={() => {
                            handleCancel()
                        }}>
                        CANCEL
                    </Button>
                </div>
            </Modal>
        </>
    )
}
const mapStateToProps = (state) => {
	const { allStudentsData } = state.classRoom;
	return {
		allStudentsData
	};
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(BatchDeleteModal);
// export default ConfirmDeleteModal